import { writable } from "svelte/store";
export const parameters = writable({
    yaw: {
        n: 5,
        d: 27,
        b: 10,
    },
    pitch: {
        n: 7,
        d: 9,
        b: 10,
    },
    distance: {
        n: 988,
        d: 999,
        b: 10,
    },
});
export const lines = writable([]);
export const scene = writable(null);
